import { RestClient } from '@/api/rest-client'
import { StatusReason } from '@/api/model/status-reason'
import { Company } from '@/api/model/company'
import { cloneDeep } from 'lodash'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { Pipeline } from '@/api/model/pipeline'
import { Status } from '@/api/model/status'

export class StatusReasonClient extends RestClient<StatusReason> {
    collectionName = 'status_reasons'
    parseData = StatusReason.fromData

    async create(data: StatusReason): Promise<StatusReason> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        if (data.phases) {
            request.phases = data.phases
                .filter((phase: PipelinePhase) => phase instanceof PipelinePhase)
                .map((phase: PipelinePhase) => phase.resourceIdentifier)
        }

        return super.create(request)
    }

    async update(id: string, data: StatusReason): Promise<StatusReason> {
        const request = cloneDeep<any>(data)

        if (data.company) {
            delete request.company
        }

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        if (data.phases) {
            request.phases = data.phases
                .filter((phase: PipelinePhase) => phase instanceof PipelinePhase)
                .map((phase: PipelinePhase) => phase.resourceIdentifier)
        }

        return super.update(id, request)
    }

    protected handleError(error: any) {
        throw error
    }
}
